export const availableLicenses = [
  {
    id: 'royalty_free',
    title: 'Royalty Free License',
    allowAi: true,
    features: [
      {
        description: 'Use this model in your own projects.',
        isActive: true,
        title: 'Sharing',
      },
      {
        description: 'Make backups or share within your team.',
        isActive: true,
        title: 'Copying',
      },
      {
        description: 'Modify, adapt, or combine with other assets.',
        isActive: true,
        title: 'Remixing',
      },
      {
        description: 'Use in paid work, products, or marketing.',
        isActive: true,
        title: 'Commercial',
      },
      {
        description: 'Selling or re-uploading the file.',
        isActive: false,
        title: 'Redistribution',
      },
      {
        description: 'Training or fine-tuning AI models.',
        isActive: true,
        title: 'AI Use',
      },
    ],
  },
  {
    id: 'royalty_free_no_ai',
    title: 'Royalty Free License',
    allowAi: false,
    features: [
      {
        description: 'Use this model in your own projects.',
        isActive: true,
        title: 'Sharing',
      },
      {
        description: 'Make backups or share within your team.',
        isActive: true,
        title: 'Copying',
      },
      {
        description: 'Modify, adapt, or combine with other assets.',
        isActive: true,
        title: 'Remixing',
      },
      {
        description: 'Use in paid work, products, or marketing.',
        isActive: true,
        title: 'Commercial',
      },
      {
        description: 'Selling or re-uploading the file.',
        isActive: false,
        title: 'Redistribution',
      },
      {
        description: 'Training or fine-tuning AI models.',
        isActive: false,
        title: 'AI Use',
      },
    ],
  },
  {
    id: 'custom',
    title: 'Custom License',
    link: '/pages/terms-and-conditions#editorial-license',
    allowAi: true,
    features: [],
  },
  {
    id: 'custom_no_ai',
    title: 'Custom License',
    allowAi: false,
    features: [
      {
        description: 'See the custom license terms for full usage rights.',
        isActive: true,
        title: 'Custom terms',
      },
      {
        description: 'Cannot be used for AI training or fine-tuning.',
        isActive: false,
        title: 'AI Use',
      },
    ],
  },
  {
    id: 'editorial',
    title: 'Editorial License',
    allowAi: false,
    features: [
      {
        description: 'Use in news, blogs, or educational projects.',
        isActive: true,
        title: 'Sharing',
      },
      {
        description: 'Make backups or share within your team.',
        isActive: true,
        title: 'Copying',
      },
      {
        description: 'Cannot modify, adapt, or combine with other assets.',
        isActive: false,
        title: 'Remixing',
      },
      {
        description: 'Not allowed in paid work, products, or marketing.',
        isActive: false,
        title: 'Commercial',
      },
      {
        description: 'Selling or re-uploading the file is prohibited.',
        isActive: false,
        title: 'Redistribution',
      },
      {
        description: 'Cannot be used for AI training or fine-tuning.',
        isActive: false,
        title: 'AI Use',
      },
    ],
  },
  {
    id: 'editorial_no_ai',
    title: 'Editorial License',
    allowAi: false,
    features: [
      {
        description: 'Use in news, blogs, or educational projects.',
        isActive: true,
        title: 'Sharing',
      },
      {
        description: 'Make backups or share within your team.',
        isActive: true,
        title: 'Copying',
      },
      {
        description: 'Cannot modify, adapt, or combine with other assets.',
        isActive: false,
        title: 'Remixing',
      },
      {
        description: 'Not allowed in paid work, products, or marketing.',
        isActive: false,
        title: 'Commercial',
      },
      {
        description: 'Selling or re-uploading the file is prohibited.',
        isActive: false,
        title: 'Redistribution',
      },
      {
        description: 'Cannot be used for AI training or fine-tuning.',
        isActive: false,
        title: 'AI Use',
      },
    ],
  },
  {
    id: 'editorial_royalty_free',
    title: 'Royalty Free License',
    allowAi: true,
    features: [
      {
        description: 'Use this model in your own projects.',
        isActive: true,
        title: 'Sharing',
      },
      {
        description: 'Make backups or share within your team.',
        isActive: true,
        title: 'Copying',
      },
      {
        description: 'Modify, adapt, or combine with other assets.',
        isActive: true,
        title: 'Remixing',
      },
      {
        description: 'Use in paid work, products, or marketing.',
        isActive: true,
        title: 'Commercial',
      },
      {
        description: 'Selling or re-uploading the file.',
        isActive: false,
        title: 'Redistribution',
      },
      {
        description: 'Training or fine-tuning AI models.',
        isActive: true,
        title: 'AI Use',
      },
    ],
  },
]
